import { Events, Numbers } from '@utilities';
import { AbstractDispatcher } from '@abstracts';

export default class ComponentFactory extends AbstractDispatcher {
  static _instance;

  constructor(_componentsList = [], container = document.body) {
    super();

    Object.assign(this, { _componentsList });

    // Singleton
    if (ComponentFactory._instance) {
      throw new Error('Error: Use ComponentFactory.instance instead of new.');
    }
    ComponentFactory._instance = this;

    this._componentInstances = [];

    // on load component parsing
    this.createComponents(container);

    // resize
    window.addEventListener(
      'resize',
      Events.debounce(this.resizeHandler.bind(this)),
      { passive: true }
    );
  }

  /**
   *  Skim through  searching for [data-component] attributes
   *
   * @private
   * @static
   * @param {HTMLElement} container
   * @returns
   * @memberof ComponentFactory
   */
  createComponents(container) {
    // we fetch all components from container
    const elComponents = Array.from(
      container.querySelectorAll('[data-component]')
    );

    // we make sure that if the container itself is a component, we got it covered
    if (container.dataset.component) {
      elComponents.push(container);
    }

    // No component, we leave and return null
    if (!elComponents) return null;

    // Generate a unique key under which will be stored these components
    const id = Numbers.createGUID();

    // We cycle through each data-component
    for (let i = 0, l = elComponents.length; i < l; i++) {
      const el = elComponents[i];

      // Split component string to an array
      const components = el.dataset.component.split(' ');

      for (let j = 0, k = components.length; j < k; j++) {
        let componentClass = components[j];

        // If the component exists, instanciate it
        console.log(this._componentsList);
        if (this._componentsList[componentClass]) {
          if (typeof this._componentInstances[id] === 'undefined') {
            this._componentInstances[id] = [];
          }

          el.dataset.componentId =
            el.dataset.componentId || Numbers.createGUID();
          const component = new this['_componentsList'][componentClass](el);

          // el.dataset.init;
          this._componentInstances[id].push(component);
        } else
          console.log(
            `ComponentFactory: ${componentClass} -> Component not found`
          );
      }
    }

    // we return the key
    return id;
  }

  /**
   *  window resize handler that triggers resize in each component
   *
   * @private
   * @memberof ComponentFactory
   */
  resizeHandler(e) {
    for (let id in this._componentInstances) {
      if (this._componentInstances.hasOwnProperty(id)) {
        let components = this._componentInstances[id];

        if (components) {
          for (let i in components) {
            let component = components[i];

            component.resize();
          }
        }
      }
    }
  }

  /**
   *  Get instance of ComponentFactory
   */
  static get instance() {
    return ComponentFactory._instance || new ComponentFactory();
  }
}
